module.exports = __webpack_public_path__ + "img/homepage-title-sk.56f47d0.svg";